export interface NavItem {
  displayName: string;
  disabled?: boolean;
  route?: string;
  children?: NavItem[];
}

export const menu: NavItem[] = [
  {
    displayName: 'Home',
    route: '/webview',
    children: [
      {
        displayName: 'Accounts',
        route: '/webview/accounts/list',
        children: [
          {
            displayName: 'Details',
            route: '/webview/account/:accountNumber/details',
          },
          {
            displayName: 'Make a Payment',
            route: '/webview/account/:accountNumber/make-payment',
          },
          {
            displayName: 'Service Request',
            route: '/webview/account/:accountNumber/service-request',
          },
          {
            displayName: 'Schedule Future Payment',
            route: '/webview/account/:accountNumber/schedule-future-payment',
          },
          {
            displayName: 'Due Date Changes',
            route: '/webview/account/:accountNumber/due-date-changes',
          },
          {
            displayName: 'Discount / Revision',
            route: '/webview/account/:accountNumber/discount',
          },
          {
            displayName: 'Manage Cards',
            route: '/webview/account/:accountNumber/manage-cards',
          },
          {
            displayName: 'Enter Cancel Date',
            route: '/webview/account/:accountNumber/free-cancellation',
          },
          {
            displayName: 'Extend Cancel Date',
            route: '/webview/account/:accountNumber/extend-cancellation',
          },
          {
            displayName: 'Defer Payment',
            route: '/webview/account/:accountNumber/defer-payment',
          },
        ],
      },
      {
        displayName: 'Service Requests',
        route: '/webview/serviceRequests/list',
      },

      {
        displayName: 'Reports',
        route: '/webview/reports/list',
        children: [
          {
            displayName: 'Active Accounts',
            route: '/webview/reports/list/active-accounts',
          },
          {
            displayName: 'ADHOC',
            route: '/webview/reports/list/adhoc',
          },
          {
            displayName: 'Callone Phone Pay',
            route: '/webview/reports/list/call-one',
          },
          {
            displayName: 'Cancelled',
            route: '/webview/reports/list/cancelled',
          },
          {
            displayName: 'Credit Card Expirations',
            route: '/webview/reports/list/credit-card-expirations',
          },
          {
            displayName: 'Dealer Contract',
            route: '/webview/reports/list/dealer-contract',
          },
          {
            displayName: 'Delinquent',
            route: '/webview/reports/list/delinquent',
          },
          {
            displayName: 'Disbursement',
            route: '/webview/reports/list/disbursement',
          },
          {
            displayName: 'Easy Pay Transaction',
            route: '/webview/reports/list/easy-pay',
          },
          {
            displayName: 'Entity Login',
            route: '/webview/reports/list/entity-logins',
          },
          {
            displayName: 'Future Pay Logs',
            route: '/webview/reports/list/future-pay',
          },
          {
            displayName: 'Mepco API Log',
            route: '/webview/reports/list/mepco-api',
          },
          {
            displayName: 'New Business',
            route: '/webview/reports/list/new-business',
          },
          {
            displayName: 'New Contract',
            route: '/webview/reports/list/new-contract',
          },
          {
            displayName: 'Paid In Full',
            route: '/webview/reports/list/paid-in-full',
          },
          {
            displayName: 'Password Reset',
            route: '/webview/reports/list/password-reset',
          },
          {
            displayName: 'Payment Authorizations',
            route: '/webview/reports/list/payment-authorizations',
          },
          {
            displayName: 'User Activity',
            route: '/webview/reports/list/user-activity',
          },
        ],
      },
      {
        displayName: 'News Feed',
        route: '/webview/newsFeed/list',
      },
      {
        displayName: 'Service Request Type',
        route: '/webview/servicerequesttype/list',
      },
      {
        displayName: 'User Administration',
        route: '/webview/userAdministration/user/list',
        children: [
          {
            displayName: 'Edit User',
            route: '/webview/userAdministration/user/info',
          },
          {
            displayName: 'Add User',
            route: '/webview/userAdministration/user/create',
          },
        ],
      },
      {
        displayName: 'User Preferences',
        route: '/webview/userPreferences/preferences',
      },
      {
        displayName: 'Dealer Portal',
        route: '/webview/dealerPortal/list',
        children: [
          {
            displayName: 'View Contract',
            route: '/webview/dealerPortal/info',
          },
        ],
      },
      {
        displayName: 'Contracts',
        route: '/webview/contracts/list',
        children: [
          {
            displayName: 'View Contract',
            route: '/webview/contracts/info',
          },
        ],
      },
    ],
  },
];
